export default () => ({
    actions: {},
});
